<template>
  <CustomTitleBar title="实名认证" />
  <div class="page-content">
    <!-- 已实名认证 -->
    <div v-if="isAuthenticated" class="auth-info">
      <div class="info-item">
        <div class="label">真实姓名</div>
        <div class="value">{{ realName }}</div>
      </div>
      <div class="info-item">
        <div class="label">身份证号码</div>
        <div class="value">{{ idNumber }}</div>
      </div>
    </div>

    <!-- 未实名认证 -->
    <div v-else class="auth-form">
      <div class="form-item">
        <div class="label">真实姓名</div>
        <input type="text" v-model="form.realName" placeholder="请输入您的姓名">
      </div>
      <div class="form-item">
        <div class="label">身份证号码</div>
        <input type="text" v-model="form.idCard" placeholder="请输入您的身份证号码">
      </div>
      <div class="form-item">
        <div class="label">手机号码</div>
        <input type="text" v-model="form.phoneNumber" placeholder="请输入您的手机号码">
      </div>
      <div class="submit-btn" @click="handleSubmit">实名认证</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { ref, onMounted } from "vue";
import { showToast } from 'vant';
import { useRouter } from 'vue-router';
const router = useRouter();

const isAuthenticated = ref(false);
const realName = ref('');
const idNumber = ref('');

const form = ref({
  realName: '',
  idCard: '',
  phoneNumber: ''
});

onMounted(() => {
  try {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    isAuthenticated.value = userInfo.authentication === 1;

    if (isAuthenticated.value) {
      realName.value = userInfo.realName || '';
      idNumber.value = userInfo.idCard || '';
    }
  } catch (error) {
    console.error('获取用户信息失败:', error);
  }
});

// 身份证号码验证
const validateIdCard = (idCard: string) => {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  return reg.test(idCard);
};

// 手机号码验证
const validatePhone = (phone: string) => {
  const reg = /^1[3-9]\d{9}$/;
  return reg.test(phone);
};

const handleSubmit = () => {
  // 验证姓名
  if (!form.value.realName.trim()) {
    showToast('请输入真实姓名');
    return;
  }

  // 验证姓名长度
  if (form.value.realName.length < 2) {
    showToast('姓名长度不能少于2个字符');
    return;
  }

  // 验证身份证
  if (!form.value.idCard) {
    showToast('请输入身份证号码');
    return;
  }
  if (!validateIdCard(form.value.idCard)) {
    showToast('请输入正确的身份证号码');
    return;
  }

  // 验证手机号
  if (!form.value.phoneNumber) {
    showToast('请输入手机号码');
    return;
  }
  if (!validatePhone(form.value.phoneNumber)) {
    showToast('请输入正确的手机号码');
    return;
  }

  // 验证通过，可以提交表单
  submitForm();
};

const submitForm = async () => {
  try {
    // TODO: 跳转设置密码
    router.push({
      path: '/SetPwd',
      query: {
        data: JSON.stringify(form.value)
      }
    })
    console.log('提交表单:', form.value);

  } catch (error) {
    console.error('提交失败:', error);
    showToast('认证失败，请重试');
  }
};
</script>

<style lang="scss" scoped>
.page-content {
  padding: 56px 16px 0;
  .auth-info,
  .auth-form {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
  }

  .info-item {
    padding: 12px 0;
    border-bottom: 1px solid #EBEDF0;

    .label {
      color: #666;
      font-size: 14px;
      margin-bottom: 8px;
    }

    .value {
      color: #333;
      font-size: 16px;
    }
  }

  .form-item {
    padding: 12px 0;
    border-bottom: 1px solid #EBEDF0;

    .label {
      color: #666;
      font-size: 14px;
      margin-bottom: 8px;
    }

    input {
      width: 100%;
      border: none;
      outline: none;
      font-size: 14px;
      color: #333;

      &::placeholder {
        color: #999;
      }
    }
  }

  .submit-btn {
    margin-top: 24px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background: $primary-color;
    color: #fff;
    border-radius: 22px;
    font-size: 16px;
  }
}
</style>
